export const MIN_PROOF_FILES = 3

export const FILE_DELETED = 'deleted'

export const proofList = proof => (Array.isArray(proof) ? proof : proof ? [proof] : [])

export const visibleProofList = proof => proofList(proof).filter(file => file?.fileStatus !== FILE_DELETED)

export const needsMoreProof = proof => visibleProofList(proof).length < MIN_PROOF_FILES

export const toProofItem = (row, file) => ({
  fileId: row.id,
  fileUuid: row.uuid,
  name: row.name ?? file?.name,
  fileStatus: 'uploaded',
})
